import { render, staticRenderFns } from "./detalheEncomenda.vue?vue&type=template&id=159ff125&scoped=true"
import script from "./detalheEncomenda.vue?vue&type=script&lang=js"
export * from "./detalheEncomenda.vue?vue&type=script&lang=js"
import style0 from "./detalheEncomenda.vue?vue&type=style&index=0&id=159ff125&prod&lang=css"
import style1 from "./detalheEncomenda.vue?vue&type=style&index=1&id=159ff125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ff125",
  null
  
)

export default component.exports